export default __webpack_public_path__ + "static/media/setup.a35f5851.svg";